import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import DataForm from './../../../components/DataForm/DataForm';
import FormInput from './../../../components/DataForm/FormInput';
import axios from '../../../axios';
import { Redirect } from 'react-router-dom';
import { Services } from '../../Service/Services';
import BoxContainer from '../../../components/BoxContainer/BoxContainer';

class OfflineCheckInRoomForm extends Component {
  // Set default state
  state = {
    data:{
      name: '',
      active: true,
    },
    datasource: {

    },
    redirect: false,
    loading: false,
  }

  retrieveData = id => {
    
  }

  componentDidMount = () => {
    const id = this.props.match.params.id;

    if(id !== undefined){
      this.retrieveData(id);
    }else{
      const loading = false;
      this.setState({loading});
    }
  }

  getValue = target => {
    let data = this.state.data;
    this.setState({
      data: {
        ...data,
        ...target
      }
    });
  }

  onSubmit = e => {
    // const params = this.state.data;
    // const url = this.props.url;
    // const redirect = true;
    // let loading = true;

    // this.setState({ loading });

    // Services.submitRequest({ params, url }).then( res => { this.setState({redirect, loading}) }).catch( errors => {this.setState({ errors,loading })});
  }

  getRedirect = () => {
    const redirect = this.state.redirect;
    
    if (redirect) {
      const url = this.props.url;

      return <Redirect to={url} />;
    }

    return;
  }

  getFields = () => {
    const id = this.state.id;

    var fields = [
      { label: 'วันที่', name: 'name', type: 'datepicker', required: true },
      { label: 'ห้อง', name: 'province', type: 'ddl', required: true },
    ];

    return fields;
  }

  render() {
    const fields = this.getFields();
    const redirect = this.getRedirect();

    return (
      <BoxContainer loading={this.state.loading} errors={this.state.errors}>
        {redirect}
        <DataForm
          fields={fields}
          onSubmit={this.onSubmit}
          allow_save={false}
          getValue={this.getValue}
        >
        <Link to='/offline/checkinroom/room' className="btn btn-primary btn-block btn-lg">
            <i className='fa fa-check'></i> ลงทะเบียน
        </Link>
        </DataForm>
      </BoxContainer>
    )
  }
}

OfflineCheckInRoomForm.setDefaultProps = {
  url: '',
}

export default OfflineCheckInRoomForm
